export default () => ({
    loading:false,
    inventory:null,
})
